import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subject, merge, of } from 'rxjs';
import { delay, switchMap, tap, catchError, shareReplay, pluck, map, skipWhile } from 'rxjs/operators';
import { PointsService } from 'src/app/home/services/points.service';
import { tabHome } from 'src/app/shared/constantes';
import { snakeToCamel } from 'src/app/utils/convertKeysObject';

@Component({
    selector: 'app-home-points',
    templateUrl: './home-points.component.html',
    styleUrls: ['./home-points.component.scss'],
    standalone: false
})
export class HomePointsComponent implements OnInit {
    @Input() content = 'points';
    @Input() pdv;
    @Output() onGoToRedeemPoints = new EventEmitter();
    @Output() onUpdatePoints = new EventEmitter();
    @Output() onUpdateResume = new EventEmitter<any>()
    faqs = [
        {
            question: 'Why is the moon sometimes out during the day?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elementum sagittis vitae et leo duis ut. Ut tortor pretium viverra suspendisse potenti.',
        },
        {
            question: 'Why is the sky blue?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elementum sagittis vitae et leo duis ut. Ut tortor pretium viverra suspendisse potenti.',
        },
        {
            question: 'Will we ever discover aliens?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elementum sagittis vitae et leo duis ut. Ut tortor pretium viverra suspendisse potenti.',
        },
    ];
    public points$: Observable<any>;
    public rewards$: Observable<any>;
    public resume$: Observable<any>;
    public reloadPoints$$: Subject<any> = new Subject();
    public reloadRewards$$: Subject<any> = new Subject();
    public statusPoints$: BehaviorSubject<string> = new BehaviorSubject(
        'initial'
    );
    public statusRewards$: BehaviorSubject<string> = new BehaviorSubject(
        'initial'
    );
    public availablePoints = null;
    public subscribePoints = null;
    public currentIncentiveIndex = 0;
    public currentIncentiveWithImage: any = null;
    public numIncentives = 0;

    constructor(
        private route: ActivatedRoute,
        private pointsService: PointsService
    ) {
        const route$ = this.route.queryParams.pipe(delay(0));
        const reload$ = route$.pipe(switchMap((data) => this.reloadPoints$$));

        this.points$ = merge(route$, reload$).pipe(
            tap(() => this.statusPoints$.next('loading')),
            switchMap(() =>
                this.pointsService.getPdvPoints().pipe(
                    tap(
                        () => this.statusPoints$.next('initial'),
                        catchError((err) => {
                            this.statusPoints$.next('error');
                            return of({});
                        })
                    )
                )
            ),
            pluck('msg'),
            map((data: any) => snakeToCamel(data)),
            map((data: any) => {
                for (let clave in data) {
                    if (data[clave] === null) {
                        data[clave] = 0;
                    }
                }
                this.availablePoints = data.pointsAvailable;
                return data;
            }),
            tap(() => this.reloadRewards$$.next('')),
            tap((points) => this.onUpdatePoints.emit(points)),
            shareReplay()
        );

        this.resume$ = merge(route$, reload$).pipe(
            tap(() => this.statusPoints$.next('loading')),
            switchMap(() =>
                this.pointsService.getPointsResume().pipe(
                catchError(err => {
                    this.statusPoints$.next('error');
                    return of([]);
                })
                )
            ),
            map((data: any[]) => {
                if (!Array.isArray(data) || data.length === 0) {
                    return [];
                }
                const response = data[0].incentives.filter((incentive: any) => {
                    if (incentive.keyname == 'league') {
                        return incentive.points != null
                    }

                    if (incentive.keyname == 'no_objective' || incentive.keyname == 'one_shot') {
                        return true;
                    }

                    if(incentive.objective_value == 0) {
                        return incentive.objective_pospaid - incentive.total_pospaid > 0 || incentive.objective_fix - incentive.total_broadband > 0
                    }

                    return true;
                });

                if (response.length > 0 && response[0].image) {
                    this.currentIncentiveWithImage = response[0];
                }

                this.numIncentives = response.length;

                return response || [];
            }),
            tap(() => this.statusPoints$.next('initial')),
            shareReplay(1)
        );

        this.resume$.subscribe(resume => this.onUpdateResume.emit(resume));

        this.rewards$ = this.reloadRewards$$.pipe(
            skipWhile(() => this.availablePoints === null),
            tap(() => this.statusRewards$.next('loading')),
            switchMap(() =>
                this.pointsService.getProducts().pipe(
                    tap(
                        () => this.statusRewards$.next('initial'),
                        catchError((err) => {
                            this.statusRewards$.next('error');
                            return of({});
                        })
                    )
                )
            ),
            pluck('msg'),
            pluck('products'),
            map((data: any) => snakeToCamel(data)),
            map((rewards) => {
                return rewards.map((reward) => {
                    let amountsAvailables = reward.amountsAvailables.map(
                        (amount) => {
                            let checkPoints =
                                this.availablePoints - amount.points;
                            return {
                                ...amount,
                                available: checkPoints >= 0,
                                tooltip: `Canjeo por ${
                                    amount.points
                                } puntos: te  ${
                                    checkPoints >= 0 ? 'sobran' : 'faltan'
                                }  ${this.getAbsoluteValue(checkPoints)}`,
                            };
                        }
                    );
                    return {
                        ...reward,
                        title: `Tarjeta regalo de ${reward.name}`,
                        amountsAvailables,
                        disableButtonRedeem:
                            this.availablePoints - reward.minPoints < 0,
                    };
                });
            }),
            shareReplay()
        );
    }

    ngOnInit(): void {
        this.reloadPoints$$.next(null);
    }

    getAbsoluteValue(value) {
        return Math.abs(value);
    }

    changeContent(_content) {
        this.content = _content;
        if (_content == 'points') {
            setTimeout(() => {
                this.reloadPoints$$.next({
                    tab: {
                        textLabel: tabHome.PUNTOS
                    }
                });
            },100);
        }
    }

    navigateToCreateOrder(reward, amount = null) {
        if (amount != null && amount.available === false) return;
        if (reward.disableButtonRedeem) return;
        this.onGoToRedeemPoints.emit({
            availablePoints: this.availablePoints,
            reward,
            amount
        });
    }

    showView() {
        return (
            this.pdv?.info?.points_terms !== null && this.pdv?.info?.points_terms !== undefined &&
            JSON.parse(this.pdv.info.points_terms)?.conditions === true
        );
    }

    onCarouselChange(array: any[], event: any) {
        const index = parseInt(event.current.replace('slideId_', ''), 10);

        if (array[index].image) {
            this.currentIncentiveWithImage = array[index];
        } else {
            this.currentIncentiveWithImage = null;
        }
    }

    protected readonly JSON = JSON;

    // Ningún o algún objetivo alcanzado de pospago y fijo
    noIncentiveCompletedShow(incentive: any) {
        return (+incentive.total_pospaid < +incentive.objective_pospaid) || (+incentive.total_broadband < +incentive.objective_fix);
    }

    countIncentivesPending(incentive: any) {
        return +incentive.objective_value - (+incentive.objective_pospaid + +incentive.objective_fix);
    }

    // Objetivos pospago y fijo cumplidos pero faltan altas para llegar al objetivo valor
    objPospaidAndFixCompletedNoValueShow(incentive: any) {
        return +incentive.total_pospaid >= +incentive.objective_pospaid && (+incentive.total_broadband >= +incentive.objective_fix) && ((+incentive.total_pospaid + +incentive.total_broadband) < +incentive.objective_value);
    }

    countIncentiveValuePending(incentive: any) {
        return +incentive.objective_value - (+incentive.total_pospaid + +incentive.total_broadband);
    }

    // Todos los objetivos cumplidos (pospago, fijo y valor)
    objPospaidFixValueCompletedShow(incentive: any) {
        return +incentive.total_pospaid >= +incentive.objective_pospaid && (+incentive.total_broadband >= +incentive.objective_fix) && ((+incentive.total_pospaid + +incentive.total_broadband) >= +incentive.objective_value);
    }

}
